import React, {useState} from 'react'
import {withRouter} from 'react-router-dom'
import * as moment from 'moment'
import { Dropdown } from 'react-bootstrap'
import { changeSingleClientModal, setActiveSelectionYear } from '../../../../../../redux/actions/single-client'
import DropdownMenu from '../../../../../universal/dropdown-menu'
import DashboardSingleClientSalesStatisticsContainer from './statistics-container'
import DashboardSingleClientSalesSearchHistoryRow from './search-container'
import EmptyTableView from '../../../../../universal/empty-table'
import DashboardSingleClientSingleSaleRow from './table-row'
import { useDispatch, useSelector } from 'react-redux'
import { TableLoader } from '../../../../../library/table-loader'
import { UpperRow } from '../../../../../library/upper-row'
import { SolidButton } from '../../../../../library/button'
import './style.scss'

const Index = props => {

	const dispatch = useDispatch()

	const loading = useSelector(state => state.singleClient.fetchSales.loading)
	const clientSales = useSelector(state => state.singleClient.sales)
	const activeSalesYear = useSelector(state => state.singleClient.activeSelectionYear)
	
	const [searchQuery, setSearchQuery] = useState("");

	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

	const selectionYears = useSelector(state => state && state.singleClient.selectionYears)

	const renderActiveDisplay = () => {
		if(selectedCompany && !loading && activeSalesYear){
		  return activeSalesYear
		} else {
		  return "Laster"
		}
	}	

	const renderToggle = () => {
		return(
			<Dropdown.Toggle disabled={loading ? true:false} id="dropdown-filter">
			  {renderActiveDisplay()} <i class="fad arrow fa-angle-down"></i>
			</Dropdown.Toggle>
		)
	}

	const clickNewSale = () => {
		dispatch(changeSingleClientModal({saleModal: true}))
	}

	const selectOptions = () => {
		const result = []
		for(var year in selectionYears){
			const item = {
				title: selectionYears[year],
				key: selectionYears[year],
				active: renderActiveDisplay() === selectionYears[year],
				action: () => dispatch(setActiveSelectionYear(selectionYears[year]))
			}
			result.push(item)
		}
		return result
	}

	const searchLibrary = e => {
        setSearchQuery(e.target.value);
    }

	const renderMainButton = () => {
		return [
			<DropdownMenu type="text-purple" size="regular" toggle={renderToggle()} title="Velg tidsperiode" options={selectOptions()}/>,
			<SolidButton icon={<i class="fad fa-plus"></i>} spacing="left" title="Nytt salg" color="purple" onClick={() => clickNewSale()} className="new-sale-button"/>
		]
	}

	return(
		<div className="single-client-sales-information">
			<div className="tab-content-container">
				<UpperRow title="Salgsoversikt" buttons={renderMainButton()}/>
				<DashboardSingleClientSalesStatisticsContainer/>
				<hr/>
				<DashboardSingleClientSalesSearchHistoryRow handleSearch={searchLibrary}/>
				<div className="sales-history-container">
					<table>
						<tr>
							<th>Dato</th>
							<th>Produktnavn</th>
							<th>Status</th>
							<th>Salgspris</th>
							<th>Handling</th>
						</tr>
						{clientSales.length > 0 && clientSales.map((sale, index, arr) => {
							if(moment.unix(sale.timestamp).year() === parseInt(activeSalesYear)){
								if(!searchQuery){
									return <DashboardSingleClientSingleSaleRow sale={sale} index={index} arr={arr}/>
								} else {
									if(sale.title.toLowerCase().includes(searchQuery.toLowerCase())){
										return(<DashboardSingleClientSingleSaleRow sale={sale} index={index} arr={arr}/>)
									}
								}
								return null
							} else {
								return null
							}
						})}	
					</table>
				</div>
				{loading ? <TableLoader/>:null}
				{!loading && clientSales.length === 0 ? <EmptyTableView title="Ingen salg tilgjengelig" description="Denne kunden har du ingen salg på enda! Du kan legge til et nytt salg ved å trykke på knappen til høyre over grafen."/>:null}
			</div>
		</div>
	)
}

export default withRouter(Index);


